import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import i18n from 'Pods/Shared/I18n'

import UserGalleryItem from './UserGalleryItem'

class UserImageGallery extends React.Component {
  constructor() {
    super()

    this.state = {
      data: [],
    }

    this.fetchData = this.fetchData.bind(this)
    this.onRequestSuccess = this.onRequestSuccess.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchData()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchData() {
    axios.get(`/api/internal/profile/${this.props.userName}/galleries`,
      { cancelToken: this.cancelSource.token })
      .then((response) => {
        this.onRequestSuccess(response)
      }).catch(this.onRequestFailure)
  }

  onRequestSuccess(response) {
    this.setState({ data: response.data.data || [] })
  }

  onRequestFailure() {
    App.events.publish('app:notification:flash:error', 'Error')
  }

  render() {
    return (
      <Fragment>
        <div className="row user-profile__gallery-row">
          {this.state.data.map((gallery) => (
            <UserGalleryItem
              key={`user-profile-gallery-${gallery.id}`}
              data={gallery.attributes}
              type="gallery"
            />
          ))}
        </div>
        {this.state.data.length > 0 && this.props.galleriesTotal > 0 && this.state.data.length < this.props.galleriesTotal && (
          <div className="user-models__load-more-row u-text-center">
            <a
              className="btn btn-outline-default text-semibold"
              href={`/gallery?author=${this.props.userName}`}
            >
              {i18n.t('browse_all_galleries', { ns: 'profile' })}
            </a>
          </div>
        )}
      </Fragment>
    )
  }
}

UserImageGallery.propTypes = {
  userName: PropTypes.string.isRequired,
  galleriesTotal: PropTypes.number.isRequired,
}

export default UserImageGallery
